import ACTION_ITEMS from './actionItems';

const initialState = {
  isLoading: false,
  message: '',
  emailSent: false,
};

export const forgotPasswordReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case ACTION_ITEMS.PASSWORD.MESSAGE.SET:
      newState = { ...state, message: action.payload.message };
      break;

    case ACTION_ITEMS.PASSWORD.IS_LOADING.SET:
      newState = { ...state, isLoading: action.payload.isLoading };
      break;

    case ACTION_ITEMS.PASSWORD.EMAIL_SENT.SET:
      newState = { ...state, emailSent: action.payload.emailSent };
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
